module.exports = __webpack_public_path__ + "img/product_3.5d8e93f.webp";